import React from "react";

import NextImage from "../NextImage";
import { getImageUrl, teamLeagueInfoUrl } from "../../../utils/generalLiveCenter";

const LeagueTableRow = ({ data, index, teams = [], sport = "rugby",
  websiteBaseUrl,
  dataPath, dataClient }) => {
  const active = teams.includes(data?.team_id);
  return (
    <tr className={`${active ? "highlight" : ""}`}>
      <td>
        <span
          className="hi-border"
          style={{ backgroundColor: `${data?.cl}` }}
        ></span>
        <span className="d-inline-block align-middle">{index + 1}</span>
      </td>
      <td>
        <div className="des-wrap">
          <span className="flg_img">
            <NextImage
              src={getImageUrl('', '', sport, data.team_id)}
              height={23}
              width={23}
              alt="teamLogo"
              priority={false}
            />
          </span>
          <a
            href={teamLeagueInfoUrl({
              dataClient,
              websiteBaseUrl,
              dataPath,
              category: "team",
              sport,
              name: data?.team?.nm,
              id: data?.team?.id,
            })}
          >

            <span className="des-text">{data?.team?.nm || data?.team}</span>
          </a>
        </div>
      </td>
      <td>{data?.pl}</td>
      <td>{data?.wo}</td>
      <td>{data?.dr}</td>
      <td>{data?.lo}</td>
      <td>{data?.sc}</td>
      <td>{data?.cc}</td>
      <td>{data?.df}</td>
      <td>{data?.pts}</td>
    </tr >
  );
};

export default LeagueTableRow;
